<template>
    <el-dialog
        :title="isForm ? (modelId ? '温控器-编辑' : '温控器-添加') : '温控器-详情'"
        :model-value="modelValue"
        top="10vh"
        width="640px"
        @close="closed"
        :close-on-click-modal="false"
    >
        <el-form
            ref="formRef"
            :model="formData"
            v-loading="loading"
            :rules="isForm ? formRules : {}"
            label-width="150px"
            label-suffix="："
            style="max-width: 560px"
        >
            <el-form-item label="IMEI" prop="IMEI">
                <el-input v-if="isForm" v-model="formData.IMEI" placeholder="请输入设备IMEI" clearable></el-input>
                <span v-else>{{ formData.IMEI }}</span>
            </el-form-item>
            <el-form-item label="安装位置" prop="location">
                <el-cascader
                    v-if="isForm"
                    filterable
                    clearable
                    v-model="formData.location"
                    :options="room_tree"
                    :props="{
                        checkStrictly: true,
                        expandTrigger: 'hover',
                        emitPath: false,
                        label: 'name',
                        value: 'id'
                    }"
                    style="width: 100%"
                    @change="handleChangeRoom"
                />
                <span v-else>{{ findNodeById(room_tree, formData.location)?.name }}</span>
            </el-form-item>
        </el-form>
        <template #footer>
            <span class="dialog-footer">
                <el-button @click="closed">取消</el-button>
                <el-button v-if="isForm" type="primary" :loading="submitLoading" @click="onConfirm">确定</el-button>
            </span>
        </template>
    </el-dialog>
</template>
<script setup>
import { defineEmits, defineProps, onMounted, ref } from 'vue'
import { addIMEI, editDeviceInfo } from '@/api/heat_meter/devicePoint.js'
import { ElMessage } from 'element-plus'
import { getOptionTree } from '@/api/room.js'

const props = defineProps({
    modelValue: {
        type: Boolean,
        required: true
    },
    modelId: {
        type: String,
        required: false
    },
    detailData: {
        type: Object,
        required: false
    },
    isForm: {
        type: Boolean,
        default: false
    }
})
const emits = defineEmits(['update:modelValue', 'updateForm'])

// 安装位置
const room_tree = ref([])
const room_list = ref({})
async function getRoomTree() {
    await getOptionTree().then((data) => {
        room_tree.value = data
        const room_locations = {}
        function getRoom(list, location) {
            list.forEach((item) => {
                if (item.children) {
                    getRoom(item.children, location + '/' + item.name)
                } else {
                    room_locations[item.id] = location.slice(1) + '/' + item.name
                }
            })
        }
        getRoom(data, '')
        room_list.value = room_locations
    })
}

// 表单源
const formData = ref({
    IMEI: '',
    room: '',
    building: '',
    location: ''
})

// 验证规则

const formRules = ref({
    room: [
        {
            required: true,
            trigger: 'blur',
            message: '请选择安装位置'
        }
    ],
    IMEI: [
        {
            required: true,
            trigger: 'blur',
            validator: (rule, value, callback) => {
                // IMEI必须为15位纯数字，且为必填项
                console.log(value)
                if (value === '') {
                    callback(new Error('请输入设备IMEI'))
                } else if (!/^[0-9]{15}$/.test(value)) {
                    callback(new Error('IMEI必须为15位纯数字'))
                } else {
                    callback()
                }
            }
        }
    ]
})
// 递归根据 ID 查找节点
function findNodeById(options, id) {
    for (const item of options) {
        if (item.id === id) {
            return item
        }
        if (item.children && item.children.length) {
            const res = findNodeById(item.children, id)
            if (res) return res
        }
    }
    return null
}

// 选择变化
function handleChangeRoom(val) {
    if (!val) {
        formData.value.room = ''
        formData.value.building = ''
        return
    }

    const node = findNodeById(room_tree.value, val)
    console.log('🚀 ~ handleChangeRoom ~ node:', node)

    // 先清空
    formData.value.room = ''
    formData.value.building = ''

    // 核心逻辑
    if (node) {
        if (node.room_type) {
            formData.value.room = node.id
            formData.value.building = node.pid
        } else {
            formData.value.building = node.id
        }
    }
}
const dialogTitle = ref('')
const submitLoading = ref(false)
const formRef = ref(null)

// 关闭
const closed = () => {
    dialogTitle.value = ''
    document.querySelector('.el-dialog__body').scrollTo(0, 0)
    emits('update:modelValue', false)
    formRef.value && formRef.value.resetFields()
}

// 确定按钮点击事件
const onConfirm = async () => {
    await handleEdit()
}

// 修改
const handleEdit = async () => {
    // 进行表单校验
    formRef.value.validate(async (valid) => {
        if (!valid) return
        submitLoading.value = true
        const data = { ...formData.value }
        delete data.location
        if (!data.room) {
            delete data.room
        }
        try {
            if (props.modelId) {
                data.id = props.modelId
                await editDeviceInfo(data)
            } else {
                await addIMEI(data)
            }
            // 模块修改成功
            emits('updateForm')
            ElMessage.success('添加成功！')
            submitLoading.value = false
            closed()
        } catch {
            submitLoading.value = false
        }
    })
}

const loading = ref(false)

onMounted(async () => {
    loading.value = true
    await getRoomTree()
    loading.value = false

    if (props.modelId) {
        console.log(props.detailData)
        const obj = { ...formData.value }
        obj.room = props.detailData.room
        obj.building = props.detailData.building
        obj.location = props.detailData.room ? props.detailData.room : props.detailData.building
        obj.IMEI = props.detailData.IMEI
        formData.value = obj
        loading.value = false
    }
})
</script>

<style scoped></style>
